// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 59423, offsets 200531:200638. Structure and names inferred from code, not screenshots.

import { module65209 as n } from "../vendor/dependencies.js";
function o(e) {
  return (0, n.y)(e);
}
export { o as z };
